const DetailAktivtyHwGuru = {
    idProfilCbt:null,
    idJadwalProfil:null,
    idGuru: null
};

export default DetailAktivtyHwGuru;